import BaseRepository from "@/baseRepository/BaseRepository";
const faqcategoriesResource = `/api/v1/faqcategories`;

export default{
      getFaqcategories(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${faqcategoriesResource}`, {
          baseURL,
          headers,
          params
        });
      },
      getFaqcategoriesactiveListByPlatform(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${faqcategoriesResource}/active-list/by-platform`, {
          baseURL,
          headers,
          params
        });
      },
      createFaqcategories(obj={},baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.post(`${faqcategoriesResource}`,obj, {
          baseURL,
          headers,
          params
        });
      },
      deleteFaqcategories(id,baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.delete(`${faqcategoriesResource}/${id}`, {
          baseURL,
          headers,
          params
        });
      },
      getDetailsFaqcategories(id,baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${faqcategoriesResource}/${id}`, {
          baseURL,
          headers,
          params
        });
      },
      updateFaqcategories(id,obj={},baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.put(`${faqcategoriesResource}/${id}`,obj, {
          baseURL,
          headers,
          params
        });
      },
      disableFaqcategories(id,baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.post(`${faqcategoriesResource}/${id}/disable`,{},{
          baseURL,
          headers,
          params
        });
      },
      enableFaqcategories(id,baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.post(`${faqcategoriesResource}/${id}/enable`,{},{
          baseURL,
          headers,
          params
        });
      },
     
}